
<template>
  <div class="invitacion-container">
    <!-- Flores (elemento2.png) grandes en las 4 esquinas del CONTENEDOR PRINCIPAL -->
    <img src="@/assets/elemento2.png" alt="Flor decorativa" class="flor-esquina top-left" />
    <img src="@/assets/flornueva.avif" alt="Flor decorativa" class="flor-esquina top-right" />
    <img src="@/assets/flornueva.avif" alt="Flor decorativa" class="flor-esquina bottom-left" />
    <img src="@/assets/elemento2.png" alt="Flor decorativa" class="flor-esquina bottom-right" />

    <!-- Estrellitas en el Contenedor Principal (Fondo Global) -->
    <div class="estrellitas-magicas fondo-global">
      <span class="estrellita-mini" style="top: 5%; left: 8%; animation-delay: 0s;">✦</span>
      <span class="estrellita-mini" style="top: 12%; left: 90%; animation-delay: 0.5s;">✧</span>
      <span class="estrellita-mini" style="top: 25%; left: 5%; animation-delay: 1.2s;">✦</span>
      <span class="estrellita-mini" style="top: 30%; left: 92%; animation-delay: 0.3s;">✧</span>
      <span class="estrellita-mini" style="top: 75%; left: 6%; animation-delay: 0.8s;">✦</span>
      <span class="estrellita-mini" style="top: 80%; left: 94%; animation-delay: 1.5s;">✧</span>
      <span class="estrellita-mini" style="top: 92%; left: 15%; animation-delay: 0.2s;">✦</span>
      <span class="estrellita-mini" style="top: 95%; left: 85%; animation-delay: 1.0s;">✧</span>
    </div>

    <!-- Tarjeta de Invitación -->
    <div class="invitacion-card" ref="cardRef">
      <!-- Estrellitas dentro de la Tarjeta -->
      <div class="estrellitas-magicas dentro-tarjeta">
        <span class="estrellita-mini" style="top: 10%; left: 15%; animation-delay: 0.1s;">✦</span>
        <span class="estrellita-mini" style="top: 18%; left: 80%; animation-delay: 0.6s;">✧</span>
        <span class="estrellita-mini" style="top: 32%; left: 20%; animation-delay: 1.0s;">✦</span>
        <span class="estrellita-mini" style="top: 38%; left: 85%; animation-delay: 0.4s;">✧</span>
        <span class="estrellita-mini" style="top: 48%; left: 12%; animation-delay: 1.3s;">✦</span>
        <span class="estrellita-mini" style="top: 55%; left: 82%; animation-delay: 0.7s;">✧</span>
        <span class="estrellita-mini" style="top: 68%; left: 16%; animation-delay: 1.6s;">✦</span>
        <span class="estrellita-mini" style="top: 75%; left: 88%; animation-delay: 0.9s;">✧</span>
        <span class="estrellita-mini" style="top: 88%; left: 25%; animation-delay: 1.1s;">✦</span>
        <span class="estrellita-mini" style="top: 92%; left: 75%; animation-delay: 0.3s;">✧</span>
      </div>

      <h1 ref="titulo" class="titulo-principal"> </h1>
      
      <!-- Nombre con efecto Dorado Cromado y animación metálica -->
      <p ref="nombres" class="subtitulo dorado-cromado">
        Angie Izabella
      </p>

      <p ref="fecha" class="fecha">Diciembre • 27 • 2026</p>

      <div class="seccion-idiomas" ref="idiomaSeccion">
        <p class="instruccion">Bienvenidos a mi Invitación</p>
        
        <!-- El sobre decorativo con brillos estrellitas titilantes puesto ARRIBA del botón -->
        <div class="sobre-superior-container">
          <img src="@/assets/sobre.png" alt="Sobre decorativo" class="imagen-sobre" />
          <div class="brillos-estrellas-sobre">
            <span class="estrellita" style="top: 15%; left: 20%; animation-delay: 0s;">✦</span>
            <span class="estrellita" style="top: 35%; left: 75%; animation-delay: 0.5s;">✧</span>
            <span class="estrellita" style="top: 60%; left: 30%; animation-delay: 1s;">✦</span>
            <span class="estrellita" style="top: 80%; left: 65%; animation-delay: 1.5s;">✧</span>
            <span class="estrellita" style="top: 25%; left: 50%; animation-delay: 0.8s;">✦</span>
            <span class="estrellita" style="top: 50%; left: 15%; animation-delay: 1.2s;">✧</span>
            <span class="estrellita" style="top: 70%; left: 85%; animation-delay: 0.3s;">✦</span>
          </div>
        </div>

        <div class="opciones-idioma">
          <!-- Botón con fondo dorado -->
          <button @click="seleccionar('es')" class="btn-idioma">
            <span>Abre aquí</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import gsap from 'gsap';

export default {
  name: 'InvitacionIdioma',
  emits: ['idioma-seleccionado'],
  setup(_, { emit }) {
    const cardRef = ref(null);
    const titulo = ref(null);
    const nombres = ref(null);
    const fecha = ref(null);
    const idiomaSeccion = ref(null);

    const seleccionar = (idioma) => {
      emit('idioma-seleccionado', idioma);
    };

    onMounted(() => {
      gsap.timeline({ delay: 0.3 })
        // Animación de las flores en las esquinas principales con tiempos distintos (stagger)
        .from('.flor-esquina', {
          opacity: 0,
          scale: 0.3,
          rotate: -25,
          stagger: 0.25, // Tiempos escalonados para cada esquina
          duration: 1.4,
          ease: 'back.out(1.5)',
        })
        .from(cardRef.value, {
          scale: 0.9,
          opacity: 0,
          duration: 1.2,
          ease: 'power3.out',
        }, '-=0.8')
        .from(titulo.value, {
          opacity: 0,
          y: -30,
          duration: 1,
          ease: 'power2.out',
        }, '-=0.8')
        .from(nombres.value, {
          opacity: 0,
          y: 30,
          duration: 1.2,
          ease: 'back.out(1.7)',
        }, '-=0.5')
        .from(fecha.value, {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: 'power2.out',
        }, '-=0.8')
        .from(idiomaSeccion.value, {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: 'power2.out',
        }, '-=0.8');
    });

    return {
      seleccionar,
      cardRef,
      titulo,
      nombres,
      fecha,
      idiomaSeccion,
    };
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=Montserrat:wght@300;400;500;700&family=Dancing+Script:wght@700&display=swap');

/* =========================================
   CONTENEDOR PRINCIPAL
   ========================================= */
.invitacion-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  margin-top: 0px;
  padding: 1rem;
  background: linear-gradient(
    rgba(223, 189, 193, 0.89),
    rgba(235, 190, 212, 0.82)
  );
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  position: relative;
  overflow: hidden;
}

/* =========================================
   FLORES GRANDES EN LAS 4 ESQUINAS PRINCIPALES
   ========================================= */
.flor-esquina {
  position: absolute;
  width: 180px !important; /* Flores más grandes */
  height: auto;
  opacity: 0.5;
  z-index: 2;
  pointer-events: none;
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.18));
}

.flor-esquina.top-left {
  top: 0;
  left: -90px !important;
  transform: rotate(0deg);
}

.flor-esquina.top-right {
  top: 0;
  right: -90px !important;
  transform: scaleX(-1);
}

.flor-esquina.bottom-left {
  bottom: 0;
  left: -90px !important;
}

.flor-esquina.bottom-right {
  bottom: 0;
  right: -90px;
  transform: rotate(180deg);
}

/* =========================================
   TARJETA DE INVITACIÓN
   ========================================= */
.invitacion-card {
  position: relative;
  padding: 80px 20px 40px 20px;
  margin: 0 auto;
  border-radius: 0 80px 0 80px;
  background:transparent;
  text-align: center;
  width: 100%;
  max-width: 380px;
  z-index: 3;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* =========================================
   ESTRELLITAS MINIS EN AMBOS CONTENEDORES
   ========================================= */
.estrellitas-magicas {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.estrellitas-magicas.fondo-global {
  z-index: 1;
}

.estrellitas-magicas.dentro-tarjeta {
  z-index: 1;
}

.estrellita-mini {
  position: absolute;
  font-size: 0.75rem;
  color: #fff8e7;
  text-shadow: 0 0 4px #ffd700, 0 0 8px #ffffff;
  animation: titilarEstrellaMini 2.2s infinite ease-in-out;
}

@keyframes titilarEstrellaMini {
  0%, 100% {
    opacity: 0.15;
    transform: scale(0.5);
  }
  50% {
    opacity: 0.95;
    transform: scale(1.3);
  }
}

/* =========================================
   TITULO Y NOMBRE (DORADO CROMADO ANIMADO)
   ========================================= */
.titulo-principal {
  font-family: 'Dancing Script', cursive;
  font-size: 2.5rem;
  color: #eae4e6;
  margin-bottom: 0.5rem;
  letter-spacing: 1px;
}

.subtitulo {
  font-family: 'british', sans-serif;
  margin-top: 20px;
  font-size: 2.9rem !important;
  margin-bottom: 1rem;
  font-weight: 700;
    padding-top: 10px;

  padding-bottom: 18px;
  letter-spacing: 1px;
}

.dorado-cromado {
  background: linear-gradient(
    135deg,
    #bf953f 0%,
    #fcf6ba 25%,
    #b38728 50%,
    #fbf5b7 75%,
    #aa771c 100%
  );
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(0px 2px 4px rgba(78, 52, 10, 0.35));
  animation: brilloCromado 3.5s linear infinite;
}

@keyframes brilloCromado {
  0% {
    background-position: 0% center;
  }
  100% {
    background-position: 200% center;
  }
}

.fecha {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.6rem !important;
  color: #faf0f3;
  margin-bottom: 1.5rem;
  letter-spacing: 1px;
}

.seccion-idiomas {
  margin: 1.5rem 0 1rem 0;
}

.instruccion {
  font-family: 'Montserrat', sans-serif;
  font-size: 1rem;
  color: #fef3f6;
  margin-bottom: 1rem;
  font-weight: 400;
}

/* Contenedor del sobre superior */
.sobre-superior-container {
  position: relative;
  width: 100%;
  max-width: 350px !important;
  margin: 0 auto 1.2rem auto;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.imagen-sobre {
  width: 100%;
  height: auto;
  filter: drop-shadow(0 4px 10px rgba(0,0,0,0.15));
}

.brillos-estrellas-sobre {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.estrellita {
  position: absolute;
  font-size: 0.85rem;
  color: #ffffff;
  text-shadow: 0 0 6px #ffffff, 0 0 12px #e0f2fe;
  animation: titilarEstrella 1.8s infinite ease-in-out;
}

@keyframes titilarEstrella {
  0%, 100% {
    opacity: 0.2;
    transform: scale(0.6);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
}

.opciones-idioma {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* Botón con imagen dorada de fondo */
.btn-idioma {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 14px;
  font-size: 1rem;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  background-image: url('@/assets/dorado.jpeg');
  background-size: cover;
  background-position: center;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 12px;
  color: #ffffff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 220px;
  margin: 0 auto;
  box-shadow: 0 4px 12px rgba(212, 175, 55, 0.4);
}

.btn-idioma:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(212, 175, 55, 0.6);
  filter: brightness(1.05);
}

/* Ajuste Adaptativo para Móviles */
@media (max-width: 480px) {
  .flor-esquina {
    width: 95px;
  }
  .invitacion-card {
    padding: 2rem 1rem;
  }
  .titulo-principal {
    font-size: 2rem;
  }
  .subtitulo {
    font-size: 2rem !important;
  }
  .fecha {
    font-size: 1.2rem !important;
  }
  .sobre-superior-container {
    max-width: 200px;
  }
}
</style>

```